export const searchAndFilterModuleComputed = {
  computed: {
    resolvedPresetFilters() {
      const filters = this.module.config.filters;
      if (!filters || !filters.options) return "";

      return filters.options
        .filter((option) => option.active && option.preset.length > 0) // Only active filters with presets
        .map(
          (option) =>
            `${option.key}:=[${option.preset
              .map((value) => `\`${value}\``) // Wrap each value in backticks
              .join(", ")}]`,
        ) // Format correctly
        .join(" && "); // Join filters with "&&"
    },
    combinedFilters() {
      if (this.coordinateFilter && this.coordinateFilter.length > 0) {
        if (
          this.resolvedPresetFilters &&
          this.resolvedPresetFilters.length > 0
        ) {
          return `${this.resolvedPresetFilters} && ${this.coordinateFilter}`;
        }
        return this.coordinateFilter;
      }
      return this.resolvedPresetFilters;
    },
  },
};
